// extracted by mini-css-extract-plugin
export default {"root":"Button_root__BGGpc","fullWidth":"Button_fullWidth__KHbU2","primary":"Button_primary__QDYyY","secondary":"Button_secondary__0KRYi"};